/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostSpendByHierarchyWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostSpendByHierarchyWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostSpendByHierarchyWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostSpendByHierarchyWidgetConfiguration>): CostSpendByHierarchyWidgetConfiguration {
        let obj = Object.assign(new CostSpendByHierarchyWidgetConfiguration(), model);
        CostSpendByHierarchyWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostSpendByHierarchyWidgetConfiguration>): CostSpendByHierarchyWidgetConfiguration {
        if (!model) return null;
        return CostSpendByHierarchyWidgetConfiguration.newInstance(<CostSpendByHierarchyWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostSpendByHierarchyWidgetConfiguration) {
        if (!obj) return;

        models.CostSpendByHierarchyWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostSpendByHierarchyWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostSpendByHierarchyWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.groupByDetails) {
            models.BillingGroupByDetails.fixupPrototype(this.groupByDetails);
        }
    }

    groupByDetails: models.BillingGroupByDetails;

}
